import { defineAction, object } from '~/prix'
import communityCreateAction from './geoCommunityCreate.action.json' assert { type: 'json' }
// import { communityObject } from '../geoCommunityObject'
// import { z } from 'zod'

const communityCreateDefinition = defineAction({
  ...communityCreateAction,

  // input: communityObject,
  // output: z.object({}),

  input: object<any>({}),
  output: object<any>({}),
})

export default communityCreateDefinition
